import { createSelector, defaultMemoize } from 'reselect';
import { denormalize } from 'normalizr';
import { linearChannels } from 'app-webtech-core/schemas';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const memoizedFetchById = defaultMemoize((id, result, entities) =>
  result.includes(id) ? denormalize(id, linearChannels.LinearChannelSchema, entities) : null,
);

const fetchByIdSelector = createSelector(
  [propertiesSelector],
  ({ result = [], entities }) => (id) => memoizedFetchById(id, result, entities),
);

export const linearChannelsFetchByIdSelector = subselect(fetchByIdSelector);
